import { BiErrorCircle } from 'react-icons/bi';

const Input = ({
  id = undefined,
  name,
  label,
  placeholder = 'enter text here',
  type = 'text',
  value,
  handleChange,
  handleKeyDown,
  error,
  disabled = false,
  grouptext,
  icon,
  iconclick,
  iconposition = 'left',
  iconclass = '',
  customclass = ''
}) => {
  return (
    <div className={`${customclass}`}>
      {label && (
        <label htmlFor={name} style={{ color: '#0678e6', fontWeight: 600 }}>
          {label}
        </label>
      )}
      <div className='input-group'>
        {/* Icon Display */}
        {icon && iconposition === 'left' && (
          <div className={`form-icon ${iconclass}`} onClick={iconclick}>
            {icon}
          </div>
        )}
        {/* Input Box Display */}
        <input
          id={id ? id : name}
          name={name}
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          type={type}
          placeholder={placeholder}
          className='form-control'
          disabled={disabled}
          autoComplete='off'
          aria-label={placeholder}
          aria-describedby='basic-addon2'
        ></input>
        {/* Icon Display */}
        {icon && iconposition !== 'left' && (
          <div className={`form-icon ${iconclass}`} onClick={iconclick}>
            {icon}
          </div>
        )}
        {/* Input Group Display */}
        {grouptext && (
          <span className='input-group-text' id='basic-addon2'>
            {grouptext}
          </span>
        )}
      </div>
      {error && (
        <div className='alert-message'>
          <BiErrorCircle /> {`  ${error}`}
        </div>
      )}
    </div>
  );
};

export default Input;
